import BudgetPeriodsTable from './BudgetPeriodsTable';
import FiscalYearsTable from './FiscalYearsTable';

const ViewPeriodsTable = () => (
  <div>
    <div className="flex flex-row min-h-[calc(100vh - 40px)]">
      <div className="w-[60%] border-r-2">
        <FiscalYearsTable />
      </div>
      <div className="w-[40%]">
        <BudgetPeriodsTable />
      </div>
    </div>
  </div>
);

export default ViewPeriodsTable;
